<template>
  <v-list density="compact" v-bind="vListProps">
    <slot name="before"></slot>
    <template v-for="(item, index) in items" :key="index">
      <!-- Top divider -->
      <v-divider v-if="item.divider === 'top'" class="mx-4 my-1" />

      <!-- Menu Entry - :value needs to be set to fix error when vuetify uses ":to" as id in useNestedItem -->
      <MenuItemsListItem :item="item" />

      <!-- Bottom divider -->
      <v-divider v-if="item.divider === 'bottom'" class="mx-4 my-1" />
    </template>
    <slot name="after"></slot>
  </v-list>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import type { MenuItem } from '~/lib/list-items'
import type { ComponentProps } from 'vue-component-type-helpers'
import type { VList } from 'vuetify/components'
import MenuItemsListItem from '~/components/Common/MenuItemsListItem.vue'

export default defineComponent({
  name: 'MenuItemsList',
  components: { MenuItemsListItem },
  props: {
    vListProps: {
      type: Object as PropType<ComponentProps<typeof VList>>,
      default: () => ({}),
    },
    items: {
      type: Array as PropType<MenuItem[]>,
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
//:deep(.v-list-item__overlay) {
//  background: rgb(var(--v-theme-primary));
//  z-index: 0;
//}
//:deep(.v-list-item__content) {
//  z-index: 1;
//}
</style>
